<template>
    <div>
        <TopBackground :titles="'病历库'" :smalls="smalls"/>
        <!-- list -->
        <div class="container-s">
            <div class="caseList">
                <div class="item" v-for="item,index in caseList" :key="index" @click="handleCaseDetail(item)">
                    <span class="date">{{item.createTime}}</span>
                    <p class="des">{{item.specPlan}}</p>
                    <p class="name">{{item.patientName}}</p>
                </div>
            </div>
            <!-- 分页 -->
            <div class="paginationMy">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import api  from '@/util/request'
const dayjs = require('dayjs')
export default {
    data() {
        return {
            smalls: ['感谢您为我们的病例库提供的优良案例，我们会将您上传的病例整理归档组合成病例库， ','您以后碰到类似病例可以在我们的病例库中进行查找'],
            caseList: [],
            currentPage: 1,
            pageSize: 20,
            total: 0
        }
    },
  mounted() {
      this.searchCase();
  },
  methods: {
        searchCase(){
          api.post('/case/list',{pageSize:this.pageSize,page:this.currentPage}).then(res=>{
            this.caseList = res.data.list ;
            this.caseList.forEach(e=>{
                e.createTime = dayjs(e.createTime).format('YYYY-MM-DD')
            })
          })
        },
        handleSizeChange() {
            this.searchCase()
        },
        handleCaseDetail(item){
            console.log(item)
            this.$router.push({path:'/caseDetail',query:{id:item.id}})
        }
    }
}
</script>

<style lang="scss" scoped>
.caseList{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 50px 0 20px;
    .item{
        border: 1px solid #E3E3E3;
        width: calc(25% - 70px);
        padding: 20px;
        margin-bottom: 30px;
        cursor: pointer;
        .date{
            color: #888;
        }
        .des{
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical; /*设置对齐模式*/
            -webkit-line-clamp: 2; /*设置多行的行数，示例为2行*/
            height: 52px;
            margin: 10px 0;
        }
        .name{
            color: #888;
        }
    }
    .item:hover{
        border: 1px solid #53CABE;
        background: #53CABE;
        color: #fff;
        .name,.date{
            color: #fff;
        }
    }
}
.paginationMy{
    text-align: right;
    padding-bottom: 100px;
}
</style>
